import React from "react";

/**
 * One figure in a row of them — the counts above the preview and the status table.
 *
 * Lifted out of BillingSyncSteps/DryRunPanel.js and Pages/ConnectWiseSyncStatus.js, which held
 * byte-identical copies. The two rows are read side by side during a sync, so they have to keep
 * looking the same; one definition is how that stays true.
 */
export default function Tally({ label, value, tone }) {
    return (
        <div className="border rounded px-3 py-2" style={{ minWidth: 130 }}>
            <div className={`fw-semibold ${tone ? `text-${tone}` : ""}`} style={{ fontSize: 20 }}>
                {value || 0}
            </div>
            <div className="text-muted" style={{ fontSize: 13 }}>{label}</div>
        </div>
    );
}
